module.exports = __webpack_public_path__ + "img/customer-1.347a7ceb.png";